import { getCurrentPrice, getHistoricalPrice } from '@/services/coingecko';
import { getCachedPrice, setCachedPrice } from '@/utils/cache';

export async function fetchCurrentPrice(coin) {
  const cachedPrice = getCachedPrice(coin);

  if (cachedPrice) return cachedPrice;

  const data = await getCurrentPrice(coin);
  const price = data[coin].usd;
  setCachedPrice(coin, price);
  return price;
}

export async function fetchHistoricalPrice(coin, date) {
  if (!date) {
    throw new Error('Date is required to fetch historical price');
  }

  const [year, month, day] = date.split('-');
  const dateString = `${day}-${month}-${year}`; // Convert to DD-MM-YYYY format for the API
  return await getHistoricalPrice(coin, dateString);
}
